import GeneralLayout from "@/layouts/General"
import CenteredHero from "@/components/CenteredHero"
import NavEngrave from "@/assets/imgs/nav-engrave.png"
import GreekLine from "@/components/GreekLine"
import Slider from "react-slick"
import clsx from "clsx"
import { useEffect, useLayoutEffect, useState, useRef } from "react"
import { useLocation } from "react-router-dom"
import { useGlobalContext } from "@/global/GlobalContext"
import RestaurantAPI from "@/app/api/di-sini/restaurant"
import Barcode from "../components/barcode"
import { NextArrowBtn, PrevArrowBtn } from "@/components/slider/Buttons"
import "@/assets/css/special-event.css"
import "@/assets/css/slider.css"
import ImageSkeleton from "@/components/skeletons/ImageSkeleton"
import ContainerSkeleton from "@/components/skeletons/ContainerSkeleton"
const restaurantApi = new RestaurantAPI()

const SpecialEvent = () => {
  const { notifyError } = useGlobalContext()
  const [imgIndex, setImgIndex] = useState(1)
  const [specialEvents, setSpecialEvents] = useState([])
  const [onReq, setOnReq] = useState(true)
  const mediaSm = window.matchMedia("(min-width: 640px)")
  const [currWindowWidth, setCurrWindowWidth] = useState(window.innerWidth)
  const [skeletonCount, setSkeletonCount] = useState(5)
  const { hash } = useLocation()
  const contactUsRef = useRef()
  const settings = {
    className: "center",
    centerMode: true,
    centerPadding: "0px",
    infinite: true,
    slidesToShow: 5,
    speed: 500,
    beforeChange: (current, next) => {
      setImgIndex(next + 1)
    },
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        // this breakpoints starts from the initial value to less
        breakpoint: 640,
        settings: {
          slidesToShow: 3,
        }
      },
    ]
  };

  useEffect(() => {
    if (hash) {
      if (hash == "#contactUs") {
        const timer = setTimeout(() => {
          if (contactUsRef.current) {
            contactUsRef.current.scrollIntoView({
              behavior: "smooth",
            });
          }
        }, 500);

        return () => clearTimeout(timer);
      }
    }
  }, [hash])

  useEffect(() => {
    getSpecialEvents()
  }, [])

  useLayoutEffect(() => {
    const handleResize = () => {
      handleSkeletonCount()

      setCurrWindowWidth(window.innerWidth)
    }

    window.addEventListener("resize", handleResize)
  }, [currWindowWidth])

  const handleSkeletonCount = () => {
    if (window.innerWidth < 640) {
      setSkeletonCount(3)
    } else {
      setSkeletonCount(5)
    }
  }

  // API request
  const getSpecialEvents = async () => {
    setOnReq(true)
    try {
      const { data } = await restaurantApi.getSpecialEvents()
      setSpecialEvents(data.data.specialEvents)
    } catch (err) {
      notifyError(err.message)
    }
    setOnReq(false)
  }

  return (
    <>
      <GeneralLayout bgColor="bg-transparent" hasGreekL={false} contentColor="text-white" relativeCls="relative -top-[50px] z-20">
        <section className="bg-[url('/src/assets/imgs/di-sini/slide02.jpeg')] bg-cover bg-center bg-no-repeat pt-36 pb-28 relative">
          <div className="px-[30px] md:px-[80px] lg:px-[130px]">
            <div className="bg-[url('/src/assets/imgs/di-sini/special-event/banner1.jpeg')] bg-cover bg-center bg-no-repeat w-full h-[350px] sm:h-[400px] md:h-[450px] lg:h-[580px] flex items-end justify-center">
              <h1 className="text-white font-light font-sloopScriptPro  sm:text-5xl md:text-6xl lg:text-7xl mb-16 sm:mb-20 lg:mb-32">Special Event</h1>
            </div>
            <div className="bg-[url('/src/assets/imgs/cultural-event/section-cover.webp')] bg-cover bg-center bg-no-repeat pt-5 pb-4">
              <div className="w-3/4 lg:w-3/5 mx-auto">
                <div className="text-center mb-8">
                  <span className="uppercase text-2xl sm:text-3xl font-agcasmlt text-[#6d625a] font-light">timeless celebrations</span>
                </div>
                <p className="font-agcasmlt font-light text-[12px] md:text-[20px] leading-[16px] sm:leading-[20px] xl:leading-[22px] text-[#6d625a] text-center">
                  Some moments are meant to be timeless.
                  From candlelit celebrations to joyful family gatherings, our home has echoed with laughter and the clink of glasses.
                  At Di Sini Di Sana, every gathering becomes a memory.
                  Come, let us host yours — with heartfelt hospitality and heritage — inspired menu.
                </p>
                <div className="mt-5 text-center">
                  <a href="#pastEvents" className="font-agcasmlt uppercase text-xl text-[#6b6059]">explore more</a>
                  <img img="100" src={NavEngrave} className="w-20 -mt-1 mx-auto" />
                </div>
              </div>
            </div>
            <CenteredHero noTitle title="Every element, every detail, and every decision is tailored to you" custTitleCls="font-americanTC text-xl sm:text-2xl w-3/4 sm:w-3/5 lg:w-2/5" custCls="bg-[url('/src/assets/imgs/di-sini/special-event/banner2.jpeg')] h-[50vh] relative" />
          </div>
        </section>
        <GreekLine custCls="relative top-1" />
        <section id="pastEvents" className="pt-10 pb-16">
          <div className="text-center mb-4">
            <span className="uppercase text-2xl sm:text-3xl font-agcasmlt text-[#6d625a] font-light mb-8">past events</span>
          </div>
          {onReq ?
            <div className="flex items-center">
              {Array.from({ length: skeletonCount }, (_, i) => (
                <div key={i} className="h-40 md:h-52 lg:h-[350px] 2xl:h-[540px] w-full">
                  <ContainerSkeleton custH="h-full" custW="w-full" custCls={i == Math.floor(skeletonCount / 2) && "slider--active-skeleton" || i != Math.floor(skeletonCount / 2) && "slider--side-skeleton"} />
                </div>
              ))}
            </div>
            :
            specialEvents.length > 0 ?
              <Slider {...settings} className="special-event-slider--custom-center">
                {specialEvents.map((m, i) => (
                  <div key={i} className={clsx("relative special-event-slide", { "special-event--activeSlide": (((((i == imgIndex || imgIndex == specialEvents.length && i == 0) && specialEvents.length == 5) || (((imgIndex == 1 && i == 0) || (i == imgIndex - 1)) && specialEvents.length > 5)) && mediaSm.matches) || (((imgIndex < 0 && i == (specialEvents.length - 3))) || (imgIndex == 1 && i == 0) && !mediaSm.matches) || (i == imgIndex - 1 && !mediaSm.matches)) })}>
                    <ImageSkeleton src={m.photo} custCls="w-full h-full object-cover" custH="h-40 md:h-52 lg:h-[350px] 2xl:h-[540px]" isDarker />
                  </div>
                ))}
              </Slider>
              :
              <p className="text-center text-gray-500">No data available.</p>
          }
        </section>
        <footer ref={contactUsRef} id="contactUs" className="bg-[url('/src/assets/imgs/cultural-event/section-cover.webp')] bg-cover bg-center bg-no-repeat">
          <div className="pt-5 pb-8">
            <div className="text-center mb-14">
              <span className="uppercase text-2xl sm:text-3xl font-agcasmlt text-[#6d625a] font-light mb-8">contact us</span>
            </div>
            <p className="font-agcasmlt font-light text-[12px] md:text-[20px] leading-[16px] sm:leading-[20px] xl:leading-[22px] text-[#6d625a] text-center">Should you have any questions or be planning a special event, please do not hesitate to contact us.</p>
            <p className="font-agcasmlt font-light text-[12px] md:text-[20px] leading-[16px] sm:leading-[20px] xl:leading-[22px] text-[#6d625a] text-center mb-8">We would be delighted to assist you.</p>
            <div className="text-center">
              <p className="font-agcasmlt font-light text-[12px] md:text-[20px] leading-[16px] sm:leading-[20px] xl:leading-[22px] text-[#6d625a] mb-1">082221000057</p>
              <div className="mt-1">
                <a href="mailto:loroblonyo@disinidisanabras.com" className="font-agcasmlt font-light text-[12px] md:text-[20px] leading-[16px] sm:leading-[20px] xl:leading-[22px] text-[#6d625a] hover:text-charcoal-black">loroblonyo@disinidisanabras.com</a>
              </div>
              <div className="mt-1">
                <a href="https://maps.app.goo.gl/KgNnWGYAzuAFCTbx8" target="_blank" className="font-agcasmlt font-light text-[12px] md:text-[20px] leading-[16px] sm:leading-[20px] xl:leading-[22px] text-[#6d625a] hover:text-charcoal-black">Jalan Raya Lungsiakan No. 57, Kedewatan<br />
                  Ubud, Bali 80571
                </a>
              </div>
            </div>
            <Barcode custCls="mx-auto" />
            <p className="font-agcasmlt font-light text-[12px] md:text-[20px] leading-[16px] sm:leading-[20px] xl:leading-[22px] text-[#6d625a] text-center my-4">Please scan to contact us.</p>
          </div>
        </footer>
      </GeneralLayout>
    </>
  )
}

const PrevArrow = (props) => {
  const { onClick } = props;
  return (
    <PrevArrowBtn onClickBtn={onClick} />
  )
}

const NextArrow = (props) => {
  const { onClick } = props;
  return (
    <NextArrowBtn onClickBtn={onClick} />
  )
}

export default SpecialEvent